import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { InputMask, Modal } from "src/components";
import { Save as SaveIcon, Cancel as CancelIcon } from "@material-ui/icons";
import { cadastrar } from "src/store/actions/entregadores";

const ENTREGADOR_SCHEMA = {
  nome: "",
  cpf: "",
  celular: "",
  veiculo: "MOTO",
  placa: "",
};

function ModalEntregadores({ open, close, entregador }) {
  const [formEntregador, setFormEntregador] = useState(entregador);

  useEffect(() => {
    if (!entregador) {
      setFormEntregador(ENTREGADOR_SCHEMA);
    } else {
      setFormEntregador(entregador);
    }
  }, [entregador]);

  const handleChange = (event) => {
    setFormEntregador({
      ...formEntregador,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async () => {
    await cadastrar({
      ...formEntregador,
      cpf: formEntregador.cpf.replaceAll(".", "").replace("-", ""),
      celular: formEntregador.celular
        .replace("(", "")
        .replace(")", "")
        .replace(" ", "")
        .replace("-", ""),
    });
    setFormEntregador(ENTREGADOR_SCHEMA);
    close();
  };

  return (
    <Modal open={open}>
      <Box display="flex" flexDirection="column" gap="8px" maxWidth="800px">
        <Typography>Adicionar entregador</Typography>
        <ValidatorForm onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item sm={8}>
              <TextValidator
                fullWidth
                label="Nome"
                name="nome"
                onChange={handleChange}
                value={formEntregador.nome}
                validators={["required"]}
                errorMessages={["Campo obrigatório"]}
                margin="dense"
              />
            </Grid>
            <Grid item sm={4}>
              <InputMask
                format="###.###.###-##"
                name="cpf"
                label="CPF"
                onChange={handleChange}
                value={formEntregador.cpf}
              />
            </Grid>
            <Grid item sm={4}>
              <InputMask
                format="(##) #####-####"
                name="celular"
                label="Celular"
                onChange={handleChange}
                value={formEntregador.celular}
              />
            </Grid>
            <Grid item sm={4}>
              <TextValidator
                fullWidth
                select
                label="Veículo"
                name="veiculo"
                onChange={handleChange}
                value={formEntregador.veiculo}
                SelectProps={{
                  native: true,
                }}
                InputLabelProps={{ shrink: true }}
                margin="dense"
              >
                <option value="MOTO"> Moto </option>
                <option value="CARRO"> Carro </option>
                <option value="BIKE"> Bike </option>
                <option value="VAN"> Van </option>
                <option value="PICAPE"> Picape </option>
                <option value="CAMINHAO"> Caminhão </option>
              </TextValidator>
            </Grid>
            <Grid item sm={4}>
              <TextValidator
                fullWidth
                label="Placa"
                name="placa"
                onChange={handleChange}
                value={formEntregador.placa}
                validators={["required"]}
                errorMessages={["Campo obrigatório"]}
                margin="dense"
              />
            </Grid>
          </Grid>

          <Box display="flex" justifyContent="flex-end">
            <Button type="submit" color="primary" size="small">
              {<SaveIcon />}&nbsp;Gravar
            </Button>
            <Button color="secondary" size="small" onClick={close}>
              {<CancelIcon />}&nbsp;Cancelar
            </Button>
          </Box>
        </ValidatorForm>
      </Box>
    </Modal>
  );
}

export default ModalEntregadores;
